import React from 'react';

interface OutlineInputFieldProps {
  value: number | string;
  placeholder?: string;
  id?: string;
  className?: string;
  maxLength?: number;
  type?: string;
  readOnly?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClick?: (e: React.MouseEvent<HTMLInputElement>) => void;
  error?: boolean;
}

const OutlineInputField = React.forwardRef<HTMLInputElement, OutlineInputFieldProps>(({ value, placeholder, onChange, id, className, maxLength, type, readOnly, onClick, error }, ref) => {
  OutlineInputField.displayName = 'OutlineInputField';

  // number 타입일 때 화살표 버튼 숨기기 위한 CSS 클래스
  const numberInputClass = type === 'number' ? '[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none' : '';

  return (
    <div className={`w-full`}>
      <input
        ref={ref}
        type={type}
        id={id}
        className={`border rounded-lg ${error ? ' border-red-500' : 'border-lawkitGray-200'} focus:outline-none focus:border-lawkitBlue-70 ${className} ${numberInputClass}`}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        maxLength={maxLength}
        readOnly={readOnly}
        onClick={onClick}
      />
    </div>
  );
});

export default OutlineInputField;
